"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const accountDashboardBannerInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Ploom Club",
  },
  {
    name: "text",
    type: "string",
    friendlyName: "Points label",
    required: true,
    defaultValue: "points",
  },
  {
    name: "background",
    type: "file",
    friendlyName: "Background image",
    required: true,
    allowedFileTypes: IMAGE_FILE_TYPES,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F2fa8fdeb1a0f4bee9b567cf3f3d7c512",
  },
  {
    name: "showCurrentTier",
    friendlyName: "Show current tier",
    type: "boolean",
    required: true,
    defaultValue: false,
  },
  {
    name: "tiers",
    friendlyName: "Tiers images",
    type: "object",
    showIf: "options.get('showCurrentTier') === true",
    defaultValue: {
      silver:
        "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F3c58691092654ec2a10a388de05b820d",
      gold: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F9c05524fdeff49e9816735df9505fc83",
      black:
        "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fe85a3845bdba4ad48388004e645edfe2",
    },
    subFields: [
      {
        name: "silver",
        type: "file",
        friendlyName: "Silver tier card image",
        required: true,
        allowedFileTypes: IMAGE_FILE_TYPES,
      },
      {
        name: "gold",
        type: "file",
        friendlyName: "Gold tier card image",
        required: true,
        allowedFileTypes: IMAGE_FILE_TYPES,
      },
      {
        name: "black",
        type: "file",
        friendlyName: "Black tier card image",
        required: true,
        allowedFileTypes: IMAGE_FILE_TYPES,
      },
    ],
    required: true,
  },
] as const satisfies Inputs;

export const AccountDashboardBannerComponent: RegisteredComponent = {
  name: "AccountDashboardBanner",
  component: dynamic(async () =>
    withValidation(
      accountDashboardBannerInputs,
      (await import("./AccountDashboardBanner")).AccountDashboardBanner,
      "AccountDashboardBanner"
    )
  ),
  inputs: accountDashboardBannerInputs,
};
